"use client";
import { useTranslations } from "next-intl";

export const BuiltByBar = () => {
  const t = useTranslations("builtBy");

  return (
    <section className="relative w-full py-20 md:py-28">
      <div className="relative mx-auto max-w-5xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-center">
          {/* Founder avatar (initial bubble until photo provided) */}
          <div className="flex justify-center md:justify-start">
            <div className="relative">
              <div
                className="absolute -inset-2 rounded-full opacity-50 blur-2xl"
                style={{
                  background:
                    "radial-gradient(circle, rgba(239,68,68,0.45), transparent 70%)",
                }}
                aria-hidden
              />
              <div className="relative flex h-32 w-32 md:h-40 md:w-40 items-center justify-center rounded-full bg-neutral-900 ring-2 ring-red-500/40 shadow-[0_0_40px_rgba(239,68,68,0.25)]">
                <span className="font-bold text-4xl md:text-5xl bg-clip-text text-transparent bg-gradient-to-br from-red-300 via-red-500 to-red-700">
                  TE
                </span>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-2 rounded-full border border-red-500/30 bg-red-500/10 px-3 py-1 text-[11px] font-medium uppercase tracking-widest text-red-300">
              <SparkIcon className="h-3 w-3 text-red-400" />
              <span>{t("eyebrow")}</span>
            </div>

            <h2 className="mt-5 text-3xl md:text-5xl font-bold leading-tight text-white tracking-tight">
              {t("headline")}
            </h2>

            <p className="mt-4 text-sm md:text-base text-neutral-400 leading-relaxed max-w-2xl">
              {t("bio")}
            </p>

            <div className="mt-6 flex flex-col md:flex-row md:items-center gap-2 md:gap-4 text-sm">
              <span className="font-medium text-white">{t("founder_name")}</span>
              <span className="hidden md:inline text-neutral-700">·</span>
              <span className="text-neutral-500">{t("founder_role")}</span>
            </div>

            <p className="mt-3 text-xs text-neutral-500 italic">
              {t("co_shaped")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const SparkIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M12 2l1.5 5L18 8.5 13.5 10 12 15l-1.5-5L6 8.5 10.5 7 12 2zm6 11l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z" />
  </svg>
);
